import FlightDetailsContainer from './FlightDetailsContainer'

export default FlightDetailsContainer
